import { z } from 'zod';
import { extendZodWithOpenApi } from '@hono/zod-openapi';
import 'zod-openapi/extend';
extendZodWithOpenApi(z);

export const GmodCustomValuesSchema = z
	.object({
		customValues: z.record(z.string(), z.any()).openapi({
			example: {
				level: 1,
				policeRank: 'Officer',
			},
			description: 'Custom values for the server',
		}),
	})
	.openapi({ ref: 'Gmod Custom Values' });

export type GmodCustomValuesInput = z.infer<typeof GmodCustomValuesSchema>;
